import React, { Component } from 'react';

/**
 * AJB Table
 */
export interface TableProps
{
    /**
     * Array of <tr> tags that will be placed inside the <tbody> tag
     */
    tbodyRows: JSX.Element[]
    /**
     * Optional array of <tr> tags that will be placed inside the <thead> tag
     */
    theadRows?: JSX.Element[]
    /**
     * Optional array of <tr> tags that will be placed inside the <tfoot> tag
     */
    tfootRows?: JSX.Element[]
    /**
     * Optional id attribute of the table
     */
    id?: string
    /**
     * Overwrite the default className of the table
     * default: 'ajb-data-table ajb-data-table--small ajb-data-table--scroll'
     */
    defaultClassName?: string
    /**
     * Add further class names to the table on top of the default
     */
    extraClassName?: string
    /**
     * Footable overloads
     */
    footable?: {
        cascade?: boolean
        expandFirst?: boolean
        hideEmpty?: boolean
    }
}
export default class Table extends Component<TableProps>
{
    static defaultProps = {
        defaultClassName: 'ajb-data-table ajb-data-table--small ajb-data-table--scroll'
    };

    render()
    {
        let className = this.props.defaultClassName;
        let extraProps: any = {};

        if ( this.props.extraClassName !== undefined ) {
            className += ` ${this.props.extraClassName}`;
        }

        if ( this.props.footable?.cascade !== undefined ) extraProps['data-cascade'] = this.props.footable.cascade ? 'true':'false';
        if ( this.props.footable?.expandFirst !== undefined ) extraProps['data-expand-first'] = this.props.footable.expandFirst ? 'true':'false';
        if ( this.props.footable?.hideEmpty !== undefined ) extraProps['data-hide-empty'] = this.props.footable.hideEmpty ? 'true':'false';

        return (
            <div className="ajb-data-table-wrapper">
                <table
                    className={className} 
                    id={this.props.id}
                    {...extraProps}
                >
                    {(this.props.theadRows !== undefined && this.props.theadRows.length > 0) &&
                    <thead>
                    {this.props.theadRows}
                    </thead>
                    }
                    <tbody>
                    {this.props.tbodyRows}
                    </tbody>
                    {(this.props.tfootRows !== undefined && this.props.tfootRows.length > 0) &&
                    <tfoot>
                    {this.props.tfootRows}
                    </tfoot>
                    }
                </table>
            </div>
        );
    }
}